export default {
  subheadline: 'These settings define how Qmulus presents your company, e.g. in the header of PDF reports.',
};
